module.exports = __webpack_public_path__ + "static/media/qqkefu.0aa61dd2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/svg/qqkefu.svg
// module id = 635
// module chunks = 0